<template>
  <component
    :is="tag"
    :class="[
      'btn',
      theme,
      size,
      color,
      active && 'active',
      rounded && 'rounded'
    ]"
  >
    <slot />
  </component>
</template>
<script>
export default {
  props: {
    tag: {
      type: String,
      default: "a",
      validator(value) {
        return ["a", "button", "router-link"].includes(value);
      }
    },
    theme: {
      type: String,
      default: "outlined",
      validator(value) {
        const themes = ["contained", "outlined", "text"];
        return themes.includes(value);
      }
    },
    color: {
      type: String,
      default: "primary",
      validator(value) {
        const colors = [
          "primary",
          "secondary",
          "tertiary",
          "inverted",
          "stability",
          "warning",
          "alert",
          "danger"
        ];
        return colors.includes(value);
      }
    },
    size: {
      type: String,
      default: "normal",
      validator(value) {
        return ["normal", "large", "small"].includes(value);
      }
    },
    active: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: variables.$fs-btn;
  text-align: center;
  text-decoration: none;
  border: 2px solid transparent;
  border-radius: 0.1rem;
  white-space: nowrap;
  transition: all 0.2s;
  line-height: 1;
  outline: 0;
  cursor: pointer;
  &.small {
    padding: 0.25rem 0.5rem;
  }
  &.large {
    padding: 0.5rem 1rem;
  }
  &--block {
    display: block;
    width: 100%;
  }
  &.outlined {
    color: variables.$primary-color;
    background: transparent;
    border-color: variables.$primary-color;
    &:hover,
    &.active {
      border-color: variables.$primary-color;
      color: variables.$text-inverted-color;
      background: variables.$primary-color;
    }
  }
  &.contained {
    color: variables.$text-inverted-color;
    background: variables.$primary-color;
    border-color: variables.$primary-color;
    &:hover,
    &:focus {
      border: 2px solid variables.$border-btn-inverted-h-color;
      background: variables.$background-btn-inverted-color;
    }
  }
  &.text {
    background: variables.$background-btn-color;
    border-color: transparent;
    &:hover,
    &.active {
      color: variables.$text-inverted-color;
      background: variables.$primary-color;
    }
  }
  &.rounded {
    border-radius: 50px;
  }
  &.active {
    cursor: initial;
  }
  &.inverted {
    border-color: #fff;
    color: #fff;
  }
  /*
  &.pagination {

  } */
}
</style>
